import { z } from 'zod';
import { fileInputToArray } from './form-data';
export const fileInputSchema = z.custom((value) => {
    const isFileArray = Array.isArray(value);
    const isFileList = typeof FileList !== 'undefined' && value instanceof FileList;
    if (!isFileArray && !isFileList)
        return false;
    return fileInputToArray(value).length > 0;
}, 'You must upload at least 1 file.');
